var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',[_c('user-form',{ref:"editFormUser",attrs:{"userData":_vm.userData},on:{"update:userData":function($event){_vm.userData=$event},"update:user-data":function($event){_vm.userData=$event},"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }